<template>
  <div class="promo-code-list wd-py-6">
    <div v-if="props.promoCodes.length > 0" class="wd-items-baseline wd-grid wd-grid-cols-1 wd-gap-3 md:wd-grid-cols-2 md:wd-gap-6">
      <PromoCodeCard
        v-for="promoCode in props.promoCodes"
        :key="promoCode.id"
        :is-active="props.isActive"
        :is-height-fixed="!isMobile"
        :promo-code-info="promoCode"
      />
    </div>
    <MemberEmptyState v-else class="promo-code-empty" :empty-text="`${$t('promo_no_promo_now')}\n${$t('promo_empty_msg_explore')}`" />
  </div>
</template>

<script setup lang="ts">
import { useBreakpoints } from '@/composition/useBreakpoints'
import PromoCodeCard from '@/components/card/PromoCodeCard.vue'
import MemberEmptyState from '@/components/member/MemberEmptyState.vue'

import type { FpromoMemberPromoCode } from '@/types/api'

interface Props {
  promoCodes: FpromoMemberPromoCode[]
  isActive: boolean
}

defineOptions({ name: 'PromoCodeList' })

const props = defineProps<Props>()

const { isMobile } = useBreakpoints()
</script>
